var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border"},[_c('a',{ref:"fb",staticClass:"twitter-timeline tw-page",attrs:{"href":_vm.$store.getters.social.Twitter.url,"data-chrome":"nofooter noborders transparent","data-height":_vm.height + 'px',"data-width":"100%","tabindex":"-1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }